import _ from "@lodash";
import { Grid, Paper, Switch, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import React from "react";
import ReactCompareImage from "react-compare-image";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
        flexGrow: 1,
    },
    labelSwitch: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        color: theme.palette.text.primary,
    },
    paper: {
        padding: "3px",
        display: "flex",
        alignItems: "center",
    },
    GridItemSwitch: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        color: theme.palette.text.primary,
    }
});

class Visualizacao02 extends XAPPComponent {

    state = {
        orientacao: false
    };

    handleSwitch = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.checked));
    };

    render() {
        const { selected, classes } = this.props;
        const form = this.state;
        var AGaleria = selected;
        var element = document.getElementById("galeriaDialogContent");
        if (element !== null) {
            var AWidth = element.clientWidth * 0.7 + "px";
        }
        return (
            <React.Fragment>
                {AGaleria !== null && AGaleria.length >= 2 &&
                    <div style={{ maxWidth: AWidth, marginLeft: "auto", marginRight: "auto" }}>
                        <div className="flex flex-col mb-8 w-full justify-center">
                            <Paper className={clsx(classes.paper, "justify-center")} elevation={0} rounded={true}>
                                <div className={classes.GridItemSwitch}>
                                    <Grid item>Vertical</Grid>
                                </div>
                                <Grid component="label" alignItems="center" spacing={1}>
                                    <Grid item>
                                        <Switch
                                            onChange={this.handleSwitch}
                                            name={"orientacao"}
                                            value={form.orientacao}
                                            checked={form.orientacao}
                                        />
                                    </Grid>
                                </Grid>
                                <div className={classes.GridItemSwitch}>
                                    <Grid item>Horizontal</Grid>
                                </div>
                            </Paper>
                        </div>
                        <ReactCompareImage
                            vertical={this.state.orientacao}
                            leftImage={AGaleria[0].base64.substring(0, "data:".length) === "data:" ? AGaleria[0].base64 : AGaleria[0].base64}
                            rightImage={AGaleria[1].base64.substring(0, "data:".length) === "data:" ? AGaleria[1].base64 : AGaleria[1].base64}
                        />
                    </div>
                }
            </React.Fragment>
        );
    }
}

function mapStateToProps({ Arquivo }) {
    return {
        Galeria: Arquivo.data,
        selected: Arquivo.selected
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(Visualizacao02)));